// TikTok's note drawn like the Material icons beside it (owner, 5 Nov 2026: the
// header's was a black logo on a white square, unlike the rest): one colour, the
// text's, in a 24-px box with the glyph about 18.5 px tall. Glyph: Font Awesome
// Free "tiktok" (CC BY 4.0); the padded viewBox sizes it. Header and Contact us.
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function TikTokIcon(props) {
  return (
    <SvgIcon viewBox="-108 -76 664 664" {...props}>
      <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0h88a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" />
    </SvgIcon>
  );
}
